import { getBooleanEnv } from '@/lib/env'

/**
 * France mode gates France-specific legal / regulatory content (territoriality, the French
 * consent wall, INS / identitovigilance, ethics, carte vitale / CGU, etc.).
 *
 * It is a COUNTRY signal, intentionally decoupled from the UI display language: a customer
 * outside France must not be shown French legal jargon even if they browse in French, and a
 * French customer must keep the mandatory content even when using the app in another language.
 *
 * Defaults to `true` so existing French deployments are unchanged. Set
 * `NEXT_PUBLIC_FRANCE_MODE=false` (or `VITE_FRANCE_MODE=false`) for customers outside France.
 */
export function isFranceMode(): boolean {
  return getBooleanEnv('NEXT_PUBLIC_FRANCE_MODE', true)
}
